// La atribución: que la campaña que trajo al cliente a la landing no se pierda al saltar a
// renfeviajes.
//
// Esto en la home no existe, y no porque se les olvidara: allí no hace falta. El cliente
// llega a renfeviajes con sus `utm_*` y su `gclid` en la URL, y navega dentro del mismo sitio,
// así que la analítica los sigue viendo. El widget rompe eso: vive en OTRO dominio, y al
// pulsar Buscar se manda al cliente a renfeviajes con una URL construida a mano. Si no se
// arrastran los parámetros de campaña, cada compra que venga de una landing se atribuye a
// "directo" y la campaña parece que no vende.
//
// Qué se arrastra:
//   - los cinco `utm_*` de siempre;
//   - los identificadores de clic: `gclid` (Google Ads), `gbraid` y `wbraid` (los que Google
//     usa cuando no hay cookies de terceros) y `msclkid` (Microsoft).
//
// DOS CUIDADOS:
//
// 1. El bloque se guarda ENTERO y se reemplaza ENTERO. Nunca clave a clave: si alguien llega
//    con una campaña y luego con otra, fusionar dejaría el `utm_source` de la primera con el
//    `utm_campaign` de la segunda, y eso es una atribución que no ocurrió nunca.
// 2. Lo que ya venga en la URL de salida MANDA. Si una landing enlaza al widget con su propio
//    `utm_campaign`, no se le pisa.

const CLAVES = [
  'utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content',
  'gclid', 'gbraid', 'wbraid', 'msclkid',
]

const GUARDADO = 'rvb-atribucion'

/** Lee de la URL actual lo que haya de campaña. */
export function leerDeLaUrl (busqueda) {
  const params = new URLSearchParams(busqueda === undefined ? window.location.search : busqueda)
  const salida = {}
  for (const clave of CLAVES) {
    const v = params.get(clave)
    if (v) salida[clave] = v
  }
  return salida
}

/**
 * Deja la atribución lista para toda la sesión. Se llama una vez, al montar.
 *
 * Si la URL trae campaña, esa manda y **sustituye** a la que hubiera. Si no trae, se conserva
 * la que ya estaba: el cliente puede haber llegado por la campaña y estar navegando por la
 * landing desde hace tres páginas.
 */
export function recordar () {
  const deLaUrl = leerDeLaUrl()
  try {
    if (Object.keys(deLaUrl).length) {
      // Entero, no clave a clave.
      window.sessionStorage.setItem(GUARDADO, JSON.stringify(deLaUrl))
      return deLaUrl
    }
    const guardado = window.sessionStorage.getItem(GUARDADO)
    return guardado ? JSON.parse(guardado) : {}
  } catch (e) {
    // sessionStorage puede no estar (navegación privada, cookies bloqueadas, un iframe con
    // permisos recortados). Sin él la atribución dura lo que dure la página, y ya.
    return deLaUrl
  }
}

/**
 * Añade la atribución a una URL de salida, sin pisar lo que ya llevara.
 * @param {string} url
 * @param {object} atribucion
 */
export function aplicar (url, atribucion) {
  if (!atribucion || !Object.keys(atribucion).length) return url
  // Se mira la query a mano en vez de con URL(): las URLs de salida llevan JSON sin escapar
  // (`rooms=[{"adultsCount":2}]`) y pasarlas por URL() las reescribiría enteras.
  const trozo = url.split('?')[1] || ''
  const yaEstan = new Set(trozo.split('&').map((p) => p.split('=')[0]))
  const nuevos = []
  for (const [clave, valor] of Object.entries(atribucion)) {
    if (yaEstan.has(clave)) continue
    nuevos.push(clave + '=' + encodeURIComponent(valor))
  }
  if (!nuevos.length) return url
  return url + (url.indexOf('?') === -1 ? '?' : '&') + nuevos.join('&')
}
